import { useTheme } from 'next-themes'
import { Toaster } from 'sonner'

/**
 * Sonner toaster that follows the app theme. With `richColors` the toast
 * text/icon palette comes from Sonner's own theme — pinned to `dark` it
 * printed light-green / light-red text on the white light-theme card.
 */
export function AppToaster() {
  const { resolvedTheme } = useTheme()
  return (
    <Toaster
      position="bottom-right"
      richColors
      closeButton
      theme={resolvedTheme === 'light' ? 'light' : 'dark'}
      toastOptions={{
        style: {
          fontFamily: 'var(--font-sans)',
          fontSize: '13px',
          borderRadius: '8px',
          border: '1px solid var(--border)',
          background: 'var(--bg-card)',
          color: 'var(--text-primary)',
        },
        classNames: {
          success: 'shadow-glow-soft',
          error: 'shadow-glow-error',
          warning: 'shadow-glow-warn',
        },
      }}
    />
  )
}
